import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`When a package fails to install or publish, the npm CLI will generate an `}<inlineCode parentName="p">{`npm-debug.log`}</inlineCode>{` file. This log file can help you figure out what went wrong.`}</p>
    <p>{`If you need to generate a `}<inlineCode parentName="p">{`npm-debug.log`}</inlineCode>{` file, you can run one of these commands.`}</p>
    <p>{`For installing packages:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install --timing
`}</code></pre>
    <p>{`For publishing packages:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm publish --timing
`}</code></pre>
    <p>{`You can find the `}<inlineCode parentName="p">{`npm-debug.log`}</inlineCode>{` file in your `}<inlineCode parentName="p">{`.npm`}</inlineCode>{` directory. To find your `}<inlineCode parentName="p">{`.npm`}</inlineCode>{` directory, use `}<inlineCode parentName="p">{`npm config get cache`}</inlineCode>{`.`}</p>
    <p>{`If you use a CI environment, your logs are likely located elsewhere. For example, in Travis CI, you can find them in the `}<inlineCode parentName="p">{`/home/travis/build`}</inlineCode>{` directory.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      